import { ref } from '@nuxtjs/composition-api'
import { useApi } from '~/composables/useApi'
import wishlistShareMutation from './useWishlistShare.gql'

interface WishlistItemComment {
  item_id: number
  comment: string
}

interface WishlistShareResponse {
  wishlistShare: {
    status: boolean
    message: string
  }
}

export const useWishlistShare = () => {
  const loading = ref(false)
  const error = ref<string | null>(null)
  const successMessage = ref('')
  const api = useApi()

  const shareWishlist = async ({
    recipient_emails,
    message,
    sharing_code,
    item_comments
  }: {
    recipient_emails: string[]
    message: string
    sharing_code: string
    item_comments?: WishlistItemComment[]
  }) => {
    loading.value = true
    error.value = null
    successMessage.value = ''

    try {
      const response = await api.query<WishlistShareResponse>(wishlistShareMutation, {
        recipient_emails,
        message,
        sharing_code,
        item_comments
      })

      const result = response.data?.wishlistShare
      if (result?.status) {
        successMessage.value = result.message || 'Wishlist shared successfully!'
      } else {
        error.value = result?.message || 'Failed to share wishlist.'
      }
    } catch (err) {
      console.error('Wishlist Share Error:', err)
      error.value = 'An error occurred while sharing the wishlist.'
    } finally {
      loading.value = false
    }
  }

  return {
    shareWishlist,
    loading,
    error,
    successMessage
  }
}
